import { ReportPeriod } from '../category-pathing-types';

export const formatInt = (n: number): string => n.toLocaleString('en-US');

// null = no follow-up timing available yet for this pair/summary.
export const formatDays = (n: number | null): string => (n === null ? '—' : `${n.toFixed(1)} days`);

export const formatCompact = (n: number): string => {
  if (n >= 1000) return `${(n / 1000).toFixed(n >= 10000 ? 0 : 1)}k`;
  return n.toLocaleString('en-US');
};

export const formatPercent = (pct: number): string => {
  if (pct <= 0) return '0%';
  if (pct < 1) return '<1%';
  return `${Math.round(pct)}%`;
};

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

// ISO date (YYYY-MM-DD) → "Mon YYYY", parsed manually to avoid timezone drift from `new Date`.
const formatMonthYear = (isoDate: string): string => {
  const [year, month] = isoDate.split('-');
  const monthLabel = MONTHS[Number(month) - 1];
  return monthLabel ? `${monthLabel} ${year}` : isoDate;
};

export const formatPeriodLabel = (period: ReportPeriod | null): string => {
  if (!period) return '';
  return `${formatMonthYear(period.reportStartDate)} – ${formatMonthYear(period.reportEndDate)}`;
};
